import { AddressPrimary } from "../../../../../../interfaces/interfaces";

interface Props {
  address: AddressPrimary;
}

const displayValueOrMissing = (value: string) => {
  if (value === "") return <div style={{ color: "red" }}>MISSING</div>;
  return value;
};

export default function AddressDetail({ address }: Props) {
  return (
    <>
      <tr>
        <th>Ship To Name</th>
        <td>{displayValueOrMissing(address.shipToName)}</td>
      </tr>
      <tr>
        <th>Ship Address</th>
        <td>{displayValueOrMissing(address.addressLine1)}</td>
      </tr>
      <tr>
        <th>Suburb</th>
        <td>{displayValueOrMissing(address.addressLine4)}</td>
      </tr>
      <tr>
        <th>City</th>
        <td>{displayValueOrMissing(address.city)}</td>
      </tr>
      <tr>
        <th>Country</th>
        <td>{displayValueOrMissing(address.country)}</td>
      </tr>
      <tr>
        <th>Post Code</th>
        <td>{displayValueOrMissing(address.postCode)}</td>
      </tr>
    </>
  );
}
